module.exports = __webpack_public_path__ + "img/p14.db76d750.svg";